import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Container, Row, Col } from 'react-bootstrap';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

export default function RegistrationModal(props) {
  // Props:
  // - show: boolean - モーダルの表示状態
  // - onHide: function - モーダルを閉じる関数
  // - email: string - 初期メールアドレス（招待の場合は変更不可）
  // - isInvitation: boolean - 招待からの登録かどうか
  // - invitationId: string - 招待ID
  // - familyId: string - 家族ID
  // - onRegistrationComplete: function - 登録完了時のコールバック

  // 初期値設定
  const [emailValue, setEmailValue] = useState('');
  
  // props.emailが変更されたときにemailValueを更新
  useEffect(() => {
    setEmailValue(props.email || '');
  }, [props.email]);
  const [loginPasswordValue, setLoginPasswordValue] = useState(''); //ユーザーのパスワード
  const [loginPasswordConfirmValue, setLoginPasswordConfirmValue] = useState(''); //新規ユーザーのパスワード再入力
  const [loginFamilyNameValue, setLoginFamilyNameValue] = useState(''); //新規ユーザーの家族名
  const [loginFirstNameValue, setLoginFirstNameValue] = useState(''); //新規ユーザーの名前
  const [loginFamilyNameKanaValue, setLoginFamilyNameKanaValue] = useState(''); //新規ユーザーの家族名(カナ)
  const [loginFirstNameKanaValue, setLoginFirstNameKanaValue] = useState(''); //新規ユーザーの名前(カナ)
  const [loginAgrrement, setLoginAgrrement] = useState(false); //個人情報保護方針の同意
  const [loginAgrrementID, setLoginAgrrementID] = useState(''); //個人情報保護方針のバージョン
  const [loginQuestionnaireValue, setLoginQuestionnaireValue] = useState(false); //新規ユーザーのアンケート協力
  const [loginPasswordAlertText, setLoginPasswordAlertText] = useState(''); //ログインパスワード警告文字列
  const [loginPasswordConfirmAlertText, setLoginPasswordConfirmAlertText] = useState(''); //ログインパスワード再入力警告文字列
  const [processing, setProcessing] = useState(false);

  //ログイン・新規作成用パスワード
  const handleLoginPasswordChange = (e) => {
    setLoginPasswordValue(e.target.value);
  };

  // パスワード入力から離れた際にチェックする
  const handleLoginPasswordBlue = (e) => {
    if (e.target.value.length < 6) {
      setLoginPasswordAlertText("パスワードは6文字以上設定してください");
    } else {
      setLoginPasswordAlertText('');
    }
  };

  //ユーザー新規登録時のパスワード再確認用
  const handleLoginPasswordConfirmChange = (e) => {
    setLoginPasswordConfirmValue(e.target.value);
  };

  // パスワード再入力からフォーカスが離れた際にチェックする
  const handleLoginPasswordConfirmBlue = (e) => {
    if (loginPasswordValue !== e.target.value) {
      setLoginPasswordConfirmAlertText("パスワードが一致しません。");
    } else {
      setLoginPasswordConfirmAlertText('');
    }
  };

  //ユーザー新規登録時用ログインユーザーの名前
  const handleLoginFirstNameChange = (e) => {
    setLoginFirstNameValue(e.target.value);
  };

  //ユーザー新規登録時用のログインユーザーの名字
  const handleLoginFamilyNameChange = (e) => {
    setLoginFamilyNameValue(e.target.value);
  };

  //ユーザー新規登録時用ログインユーザーの名前（カナ）
  const handleLoginFirstNameKanaChange = (e) => {
    setLoginFirstNameKanaValue(e.target.value);
  };

  //ユーザー新規登録時用のログインユーザーの名字（カナ）
  const handleLoginFamilyNameKanaChange = (e) => {
    setLoginFamilyNameKanaValue(e.target.value);
  };

  // 個人情報保護方針の同意
  const handleAgreementChange = (e) => {
    setLoginAgrrement(e.target.checked);
    setLoginAgrrementID(e.target.id);
  };

  // ユーザーアンケート同意
  const handleQuestionnaireChange = (e) => {
    setLoginQuestionnaireValue(e.target.checked);
  };

  // 招待ユーザーの登録処理
  const registInvitationUser = (uid, resolve, reject) => {
    const db = firebase.firestore();
    
    // 招待ユーザーの登録
    db.collection("Family").doc(props.familyId).collection("Editor").doc(uid)
      .set({ Permission: "owner" })
      .then(() => {
        // 「Person」にログインユーザーの情報を登録する
        db.collection("Person").doc(uid).set({
          Email: emailValue,
          FamilyName: loginFamilyNameValue,
          FirstName: loginFirstNameValue,
          FamilyName_Kana: loginFamilyNameKanaValue,
          FirstName_Kana: loginFirstNameKanaValue,
          Agrrement: loginAgrrement,
          CreateTime: firebase.firestore.FieldValue.serverTimestamp(),
          UpdateTime: firebase.firestore.FieldValue.serverTimestamp(),
          AgrrementID: loginAgrrementID,
          Questionnaire: loginQuestionnaireValue,
          FamilyID: [{
            id: props.familyId,
            CanAccess: true
          }]
        })
        .then(() => {
          // 招待の完了フラグを設定
          if (props.invitationId) {
            // Invitation/(InvitationID) の更新
            db.collection("Invitation").doc(props.invitationId)
              .update({
                Completion: true,
                UpdateTime: firebase.firestore.FieldValue.serverTimestamp()
              })
              .then(() => {
                
                // Family/(FamilyID)/Invitation/(InvitationID) の更新
                if (props.invitationId) {
                  db.collection("Family").doc(props.familyId).collection("Invitation").doc(props.invitationId)
                    .update({
                      Completion: true,
                      UpdateTime: firebase.firestore.FieldValue.serverTimestamp()
                    })
                    .then(() => {
                      console.log("RegistrationModal.js Family Invitation updated");
                      resolve();
                    })
                    .catch((error) => {
                      console.log("Error updating Family Invitation: ", error);
                      reject();
                    });
                } else {
                  resolve();
                }
              })
              .catch((error) => {
                console.log("Error updating Invitation: ", error);
                reject();
              });
          } else {
            resolve();
          }
        })
        .catch((error) => {
          console.log("Error registUserInfomation Person documents: ", error);
          reject();
        });
      })
      .catch((error) => {
        console.log("Error registUserInfomation Editor documents: ", error);
        reject();
      });
  };

  // 通常ユーザーの登録処理
  const registRegularUser = (uid, resolve, reject) => {
    const db = firebase.firestore();
    
    // 通常の新規登録処理
    // 新規作成した家族IDを取得する。
    db.collection("Family").add({ FamilyName: loginFamilyNameValue })
      .then((result) => {
        const newFamilyId = result.id;

        // Editorにオーナー権限で登録を行う。
        db.collection("Family").doc(newFamilyId).collection("Editor").doc(uid)
          .set({ Permission: "owner" })
          .then(() => {
            // 「Person」にログインユーザーの情報を登録する。
            db.collection("Person").doc(uid).set({
              Email: emailValue,
              FamilyName: loginFamilyNameValue,
              FirstName: loginFirstNameValue,
              FamilyName_Kana: loginFamilyNameKanaValue,
              FirstName_Kana: loginFirstNameKanaValue,
              Agrrement: loginAgrrement,
              CreateTime: firebase.firestore.FieldValue.serverTimestamp(),
              UpdateTime: firebase.firestore.FieldValue.serverTimestamp(),
              AgrrementID: loginAgrrementID,
              Questionnaire: loginQuestionnaireValue,
              FamilyID: [{
                id: newFamilyId,
                CanAccess: true
              }]
            })
            .then(() => { 
              console.log("RegistrationModal.js registUserInfomation family created");
              resolve();
            })
            .catch((error) => {
              console.log("Error registUserInfomation Person documents: ", error);
              reject();
            });
          })
          .catch((error) => {
            console.log("Error registUserInfomation Editor documents: ", error);
            reject();
          });
      })
      .catch((error) => {
        console.log("Error registUserInfomation Family documents: ", error);
        reject();
      });
  };

  // ユーザー情報登録時のルーティング
  const registUserInfomation = (uid) => {
    return new Promise((resolve, reject) => {
      console.log("RegistrationModal.js registUserInfomation call uid: " + uid);
      
      // 招待ユーザーの登録か通常登録かで処理を分岐
      if (props.isInvitation && props.familyId) {
        // 招待ユーザーの登録
        registInvitationUser(uid, resolve, reject);
      } else {
        // 通常の新規登録処理
        registRegularUser(uid, resolve, reject);
      }
    });
  };

  // ユーザー新規登録処理
  const handleUserRegist = () => {
    let user = [];
    Promise.resolve()
      .then(() => {
        return new Promise((resolve) => {
          // バリデーションチェック
          const regex = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/; //メールアドレスの正規表現文字列
          const katakanaRegex = /^[ァ-ヶー]+$/;

          // メールアドレスの形式チェック
          if (!regex.test(emailValue)) {
            alert('メールアドレスの形式が間違っています。\n正しいメールアドレスを入力してください。');
            return;
          }

          // パスワードの長さチェック
          if (loginPasswordValue.length < 6) {
            alert('パスワードは6文字以上で設定してください。');
            return;
          }

          // パスワード確認チェック
          if (loginPasswordValue !== loginPasswordConfirmValue) {
            alert('パスワードが一致しません。');
            return;
          }

          // 姓の必須チェック
          if (!loginFamilyNameValue.trim()) {
            alert('姓を入力してください');
            return;
          }

          // 名の必須チェック
          if (!loginFirstNameValue.trim()) {
            alert('名を入力してください');
            return;
          }

          // 姓（カタカナ）の形式チェック
          if (!loginFamilyNameKanaValue.trim() || !katakanaRegex.test(loginFamilyNameKanaValue)) {
            alert('姓（カタカナ）はカタカナで入力してください');
            return;
          }

          // 名（カタカナ）の形式チェック
          if (!loginFirstNameKanaValue.trim() || !katakanaRegex.test(loginFirstNameKanaValue)) {
            alert('名（カタカナ）はカタカナで入力してください');
            return;
          }

          // 個人情報保護方針に同意がない場合は、同意を必須とする。
          if (loginAgrrement === false) {
            alert('個人情報保護方針の同意が必要です。');
            return;
          }

          resolve();
        });
      })
      .then(() => {
        return new Promise((resolve) => {
          // 新規登録処理中画面に移動
          setProcessing(true);
          resolve();
        });
      })
      .then(() => {
        return new Promise((resolve, reject) => {
          // メールアドレスとパスワードを使用して、新しいユーザーを登録する。
          firebase.auth().createUserWithEmailAndPassword(emailValue, loginPasswordValue)
            .then((result) => {
              user = result.user;
              console.log("create user UID: " + user.uid);
              resolve();
            })
            .catch((error) => {
              if (error.code === 'auth/email-already-in-use') {
                alert('ユーザー登録に失敗。\nメールアドレスは既に他のアカウントで登録されています。');
              } else if (error.code === 'auth/invalid-email') {
                alert('ユーザー登録に失敗。\nメールアドレスの形式が正しくありません。');
              } else {
                alert('ユーザー登録に失敗。\n(' + error.message + ')');
              }
              setProcessing(false);
              reject();
            });
        });
      })
      .then(() => {
        return new Promise((resolve, reject) => {
          // 既存のユーザーをログインさせる
          firebase.auth().signInWithEmailAndPassword(emailValue, loginPasswordValue)
            .then(() => {
              registUserInfomation(user.uid)
                .then(() => {
                  firebase.auth().currentUser.updateProfile({
                    displayName: loginFamilyNameValue + " " + loginFirstNameValue,
                  })
                  .then(() => {
                    resolve();
                  });
                })
                .catch((error) => {
                  alert('会員登録処理中にエラーが発生しました。管理者にお問い合わせください。');
                  // 処理中状態を解除してログアウト
                  setProcessing(false);
                  firebase.auth().signOut().finally(() => {
                    reject(error);
                  });
                });
            })
            .catch((error) => {
              // サインイン自体が失敗した場合のハンドリング
              alert('サインインに失敗しました。時間をおいて再度お試しください。');
              setProcessing(false);
              reject(error);
            });
        });
      })
      .then(() => {
        console.log('メールアドレスの認証操作が必要です。');
        var actionCodeSettings = {
          url: 'https://dev-app.famikar.jp/',
          handleCodeInApp: false,
        };
        return firebase.auth().currentUser.sendEmailVerification(actionCodeSettings)
          .then(() => {
            console.log('メールアドレス確認用のメールをお送りしました。 送信先アドレス：' + user.email);
            alert('メールアドレス確認用のメールをお送りしました。\n送信先アドレス：' + user.email);
            
            // 処理完了
            setProcessing(false);
            
            // ログアウトしてからログイン画面に遷移
            return firebase.auth().signOut().then(() => {
              props.onRegistrationComplete();
            });
          })
          .catch((error) => {
            alert('メールアドレス確認メールの送信に失敗しました。\n登録メールアドレス(' + user.email + ')\n' + error.message);
            
            // エラーが発生しても処理を完了し、ログアウトしてログイン画面に遷移
            setProcessing(false);
            return firebase.auth().signOut().then(() => {
              props.onRegistrationComplete();
            });
          });
      })
      .catch((error) => {
        console.log("Error in registration process:", error);
        firebase.auth().signOut();
        setProcessing(false);
      });
  };

  return (
    <>
      {/* 会員登録画面（modal） */}
      <Modal show={props.show} onHide={props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>会員登録</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group controlId="formRegistFamilyName">
                    <Form.Label>姓</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="formRegistFamilyName" 
                      autoComplete="family-name"
                      value={loginFamilyNameValue} 
                      onChange={(e) => handleLoginFamilyNameChange(e)} 
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formRegistFirstName">
                    <Form.Label>名</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="formRegistFirstName" 
                      autoComplete="given-name"
                      value={loginFirstNameValue} 
                      onChange={(e) => handleLoginFirstNameChange(e)} 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group controlId="formRegistFamilyNameKana">
                    <Form.Label>姓（カタカナ）</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="formRegistFamilyName_Kana"
                      value={loginFamilyNameKanaValue} 
                      onChange={(e) => handleLoginFamilyNameKanaChange(e)} 
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formRegistFirstNameKana">
                    <Form.Label>名（カタカナ）</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="formRegistFirstName_Kana"
                      value={loginFirstNameKanaValue} 
                      onChange={(e) => handleLoginFirstNameKanaChange(e)} 
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group controlId="formRegistEmail">
                <Form.Label>Eメールアドレス{props.isInvitation ? "（変更不可）" : ""}</Form.Label>
                <Form.Control 
                  type="email" 
                  name="formRegistEmail" 
                  autoComplete='email'
                  value={emailValue} 
                  onChange={(e) => setEmailValue(e.target.value)}
                  disabled={props.isInvitation} 
                />
              </Form.Group>

              <Form.Group controlId="formRegistPassword">
                <Form.Label>パスワード ※6文字以上</Form.Label>
                {loginPasswordAlertText !== '' ? (<div style={{ color: 'red' }}>{loginPasswordAlertText}</div>) : (<div style={{ display: 'none' }}></div>)}
                <Form.Control 
                  type="password" 
                  name="formRegistPassword" 
                  minLength="6" 
                  placeholder="設定するパスワードを入力してください" 
                  autoComplete="new-password"
                  value={loginPasswordValue} 
                  onChange={(e) => handleLoginPasswordChange(e)} 
                  onBlur={(e) => handleLoginPasswordBlue(e)} 
                />
              </Form.Group>

              <Form.Group controlId="formRegistPassword_confirm">
                <Form.Label>パスワード確認</Form.Label>
                {loginPasswordConfirmAlertText !== '' ? (<div style={{ color: 'red' }}>{loginPasswordConfirmAlertText}</div>) : (<div style={{ display: 'none' }}></div>)}
                <Form.Control 
                  type="password" 
                  name="formRegistPassword_confirm" 
                  minLength="6" 
                  placeholder="設定するパスワードを再入力してください" 
                  autoComplete="off"
                  value={loginPasswordConfirmValue} 
                  onChange={(e) => handleLoginPasswordConfirmChange(e)} 
                  onBlur={(e) => handleLoginPasswordConfirmBlue(e)} 
                />
              </Form.Group>

              <Form.Group controlId="formAgrrementCheckbox">
                <Form.Text className="text-muted">
                  <a href="https://famikar.jp/privacy/" target="_blank" rel="noopener noreferrer">個人情報保護方針</a>
                </Form.Text>
                <Form.Check 
                  type="checkbox" 
                  id="privacy_20221225" 
                  checked={loginAgrrement}
                  onChange={(e) => handleAgreementChange(e)} 
                  label="個人情報保護方針に同意します。（必須）" 
                />
              </Form.Group>

              <Form.Group controlId="formQuestionnaireCheckbox">
                <Form.Text className="text-muted">
                  アプリご利用にあたり、ユーザー様にアプリ利用に関するアンケートをお願いしています。<br />
                  アンケートにご協力頂ける方は、改めて連絡させて頂きたく、下記の項目でチェックを付けて頂けますと幸いです。（任意）
                </Form.Text>
                <Form.Check 
                  type="checkbox" 
                  checked={loginQuestionnaireValue}
                  onChange={(e) => handleQuestionnaireChange(e)} 
                  label="アンケートに協力します。" 
                />
              </Form.Group>
            </Form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={props.onHide}>
            キャンセル
          </Button>
          <Button variant="primary" onClick={() => handleUserRegist()}>登録</Button>
        </Modal.Footer>
      </Modal>

      {/* 処理中画面（modal） */}
      <Modal show={processing}>
        <Modal.Header>
          <Modal.Title>会員登録 - 処理中</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <div style={{margin: '7em 0'}}>
              会員登録処理中<br />
              画面を閉じないでください。
            </div>
          </Container>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    </>
  );
}
